import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.sass'],
})
export class DatePickerComponent implements OnInit {
  @Input()
  config: IFieldConfig;
  @Input()
  group: FormGroup;
  @Input()
  typeCes?: TypeCesEnum | undefined;

  constructor() {}

  ngOnInit(): void {}
}
